<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import PromoItemCard from './Promotions/molecules/PromoItemCard.svelte';
	import { format } from 'svelte-i18n';

	export let discountsNotification: number | undefined;
	export let classNames: string = '';
	export let title: string;
	export let text: string;
	export let icon: string = '';
	export let image: string = '';
	export let expiryText: string | { key: string; object: object };
	export let hasNotification: boolean = false;

	$: expiryTextFormatted =
		typeof expiryText === 'string' ? expiryText : $format(expiryText?.key, expiryText?.object);

	const dispatch = createEventDispatcher();

	$: resolvedHasNotification =
		hasNotification || (discountsNotification !== undefined && discountsNotification > 0);
</script>

<PromoItemCard
	{icon}
	{image}
	{title}
	{text}
	expiryText={expiryTextFormatted}
	hasNotification={resolvedHasNotification}
	{classNames}
	on:click={() => dispatch('click')}
/>
